var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _g3, _g4, _g5, _g6, _path8, _path9, _g7, _g8, _path10, _rect, _g9, _path11, _path12, _path13, _path14, _polygon, _path15, _path16, _polygon2, _polygon3, _path17, _g10, _path18, _path19, _polygon4, _g11, _rect2, _path20, _path21, _polygon5, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _rect3, _path61, _path62, _path63, _path64, _path65, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 320.94",
    style: {
      enableBackground: "new 0 0 500 320.94"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{opacity:0.7;fill:url(#SVGID_5_);enable-background:new    ;}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n\t.st10{fill:#84ACB9;}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{fill:url(#SVGID_11_);}\n\t.st13{fill:url(#SVGID_12_);}\n\t.st14{fill:url(#SVGID_13_);}\n\t.st15{fill:url(#SVGID_14_);}\n\t.st16{fill:url(#SVGID_15_);}\n\t.st17{fill:#AFD4C2;}\n\t.st18{fill:url(#SVGID_16_);}\n\t.st19{fill:url(#SVGID_17_);}\n\t.st20{fill:url(#SVGID_18_);}\n\t.st21{fill:url(#SVGID_19_);}\n\t.st22{opacity:0.3;}\n\t.st23{opacity:0.7;fill:url(#SVGID_20_);enable-background:new    ;}\n\t.st24{opacity:0.7;fill:url(#SVGID_21_);enable-background:new    ;}\n\t.st25{opacity:0.7;fill:url(#SVGID_22_);enable-background:new    ;}\n\t.st26{fill:url(#SVGID_23_);}\n\t.st27{fill:url(#SVGID_24_);}\n\t.st28{fill:url(#SVGID_25_);}\n\t.st29{fill:url(#SVGID_26_);}\n\t.st30{fill:url(#SVGID_27_);}\n\t.st31{opacity:0.7;fill:url(#SVGID_28_);enable-background:new    ;}\n\t.st32{fill:url(#SVGID_29_);}\n\t.st33{opacity:0.3;enable-background:new    ;}\n\t.st34{fill:url(#SVGID_30_);}\n\t.st35{opacity:0.7;fill:url(#SVGID_31_);enable-background:new    ;}\n\t.st36{fill:url(#SVGID_32_);}\n\t.st37{fill:url(#SVGID_33_);}\n\t.st38{opacity:0.5;enable-background:new    ;}\n\t.st39{fill:url(#SVGID_34_);}\n\t.st40{fill:url(#SVGID_35_);}\n\t.st41{opacity:0.7;fill:url(#SVGID_36_);enable-background:new    ;}\n\t.st42{opacity:0.7;fill:url(#SVGID_37_);enable-background:new    ;}\n\t.st43{fill:url(#SVGID_38_);}\n\t.st44{fill:url(#SVGID_39_);}\n\t.st45{fill:url(#SVGID_40_);}\n\t.st46{fill:#FDCEDC;}\n\t.st47{fill:url(#SVGID_41_);}\n\t.st48{fill:url(#SVGID_42_);}\n\t.st49{fill:url(#SVGID_43_);}\n\t.st50{fill:url(#SVGID_44_);}\n\t.st51{fill:url(#SVGID_45_);}\n\t.st52{fill:url(#SVGID_46_);}\n\t.st53{fill:url(#SVGID_47_);}\n\t.st54{fill:url(#SVGID_48_);}\n\t.st55{fill:url(#SVGID_49_);}\n\t.st56{font-family:'LeagueSpartan-Bold';}\n\t.st57{font-size:13.0722px;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.05,
    y1: -954.5835,
    x2: 463.6729,
    y2: -574.1855,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAD3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EABB8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,317.68V49.71c-18.52,23-57.15,31.73-76.07,31.73c-25.42,0-100.95,8.23-100.95,70.69 s-45.09,31.41-94.41,80.73c-35.17,35.17-58.82,88.09-137.26,88.09h405.42C498.54,320.94,500,319.48,500,317.68z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -486.8363,
    y1: -1279.3182,
    x2: -242.5653,
    y2: -1279.3182,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -77.3522 -1107.2351)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA283"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBA37D"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M468.54,98.35V201.6c0,5.31-4.3,9.61-9.61,9.61H256.47c-5.31,0-9.6-4.3-9.6-9.61V98.35 c0-5.31,4.29-9.61,9.6-9.61h202.46C464.23,88.74,468.54,93.04,468.54,98.35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M447.54,205.36H260.8c-1.46,0-2.64-1.18-2.64-2.64V97.23c0-1.46,1.18-2.64,2.64-2.64h186.73 c1.46,0,2.64,1.18,2.64,2.64v105.49C450.18,204.18,449,205.36,447.54,205.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -470.2664,
    y1: -1274.3757,
    x2: -466.027,
    y2: -1274.3757,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -94.7862 -1162.5276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M252.69,152.09c-1.17,0-2.12-0.95-2.12-2.12s0.95-2.12,2.12-2.12s2.12,0.95,2.12,2.12 S253.86,152.09,252.69,152.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -269.1555,
    y1: -1284.0961,
    x2: -260.4965,
    y2: -1284.0961,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -60.5221 -1053.8557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M459.09,154.31c-2.39,0-4.33-1.94-4.33-4.33s1.94-4.33,4.33-4.33c2.39,0,4.33,1.94,4.33,4.33 C463.42,152.37,461.48,154.31,459.09,154.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.42,
    y1: -694.864,
    x2: 441.9,
    y2: -694.864,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAD3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EABB8"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M439.62,196.42H269.7c-1.26,0-2.28-1.02-2.28-2.28v-89.45c0-1.26,1.02-2.28,2.28-2.28h169.92 c1.26,0,2.28,1.02,2.28,2.28v89.45C441.9,195.4,440.88,196.42,439.62,196.42z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.18,183.36L291.18,183.36c0.29,0,0.53,0.24,0.53,0.53v3.27c0,0.29-0.24,0.53-0.53,0.53l0,0 c-0.29,0-0.53-0.24-0.53-0.53v-3.27C290.65,183.59,290.89,183.36,291.18,183.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.27,183.36L293.27,183.36c0.29,0,0.53,0.24,0.53,0.53v3.27c0,0.29-0.24,0.53-0.53,0.53l0,0 c-0.29,0-0.53-0.24-0.53-0.53v-3.27C292.74,183.59,292.97,183.36,293.27,183.36z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M430.75,173.02H278.57H430.75z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.57,
    y: 172.48,
    className: "st2",
    width: 152.17,
    height: 1.09
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M337.01,177.64c-1.37,0-2.48-1.11-2.48-2.48v-4.56c0-1.37,1.11-2.48,2.48-2.48c1.37,0,2.48,1.11,2.48,2.48 v4.56C339.49,176.53,338.38,177.64,337.01,177.64z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.8,185.18l-3.06-1.77c-0.26-0.15-0.59,0.04-0.59,0.34v3.53c0,0.3,0.33,0.49,0.59,0.34l3.06-1.77 C304.06,185.71,304.06,185.33,303.8,185.18z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305.36,187.69L305.36,187.69c-0.29,0-0.53-0.24-0.53-0.53v-3.27c0-0.29,0.24-0.53,0.53-0.53l0,0 c0.29,0,0.53,0.24,0.53,0.53v3.27C305.89,187.45,305.65,187.69,305.36,187.69z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.66,185.87l3.06,1.77c0.26,0.15,0.59-0.04,0.59-0.34v-3.53c0-0.3-0.33-0.49-0.59-0.34l-3.06,1.77 C280.4,185.34,280.4,185.72,280.66,185.87z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.1,183.36L279.1,183.36c0.29,0,0.53,0.24,0.53,0.53v3.27c0,0.29-0.24,0.53-0.53,0.53l0,0 c-0.29,0-0.53-0.24-0.53-0.53v-3.27C278.57,183.59,278.81,183.36,279.1,183.36z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M430.31,187.77h-4.49c-0.3,0-0.54-0.24-0.54-0.54v-3.4c0-0.3,0.24-0.54,0.54-0.54h4.49 c0.3,0,0.54,0.24,0.54,0.54v3.4C430.85,187.52,430.61,187.77,430.31,187.77z M426.37,186.68h3.4v-2.31h-3.4V186.68z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.03,137.15l-18.61-10.74c-1.6-0.92-3.59,0.23-3.59,2.08v21.48c0,1.84,2,3,3.59,2.08l18.61-10.74 C368.62,140.37,368.62,138.07,367.03,137.15z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -430.9945,
    y1: -1244.2557,
    x2: -344.4471,
    y2: -1244.2557,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -61.9577 -1135.6609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DB1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M374.85,88.74v32.91c0,2.98-4.12,5.41-9.21,5.41h-63.43c-5.09,0-9.23-2.43-9.23-5.41V88.74H374.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -330.2092,
    y1: -1239.2041,
    x2: -281.0386,
    y2: -1239.2041,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -44.7735 -1083.4392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DB1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDFFFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M442.34,114.36l-8,2.22l-2.23,8l-14.19-14.2c-0.46-0.06-0.9-0.11-1.35-0.11s-0.9,0.04-1.35,0.11l-14.2,14.2 l-2.22-8l-8.01-2.22l10.87-10.87c-0.73-1.44-0.66-3.32-1.17-4.89c-0.56-1.71-1.98-3.34-1.98-5.23c0-1.67,1.11-3.14,1.75-4.63 h32.62c0.63,1.49,1.74,2.96,1.74,4.63c0,1.89-1.43,3.52-1.97,5.23c-0.51,1.57-0.44,3.45-1.18,4.89L442.34,114.36z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M412.75,187.77h-1.94c-0.3,0-0.54-0.24-0.54-0.54c0-0.3,0.24-0.54,0.54-0.54h1.94 c0.46,0,0.96-0.64,1.48-1.31c0.76-0.98,1.62-2.09,3.01-2.09h1.54c0.3,0,0.54,0.24,0.54,0.54c0,0.3-0.24,0.54-0.54,0.54h-1.54 c-0.85,0-1.51,0.85-2.15,1.67C414.43,186.89,413.75,187.77,412.75,187.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "418.47,184.85 420.26,183.82 418.47,182.79  "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M418.77,187.77h-1.54c-1.39,0-2.25-1.11-3.01-2.09c-0.52-0.67-1.01-1.31-1.48-1.31h-1.94 c-0.3,0-0.54-0.24-0.54-0.54c0-0.3,0.24-0.54,0.54-0.54h1.94c1,0,1.68,0.88,2.34,1.73c0.64,0.82,1.3,1.67,2.15,1.67h1.54 c0.3,0,0.54,0.24,0.54,0.54C419.32,187.52,419.07,187.77,418.77,187.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "418.47,188.25 420.26,187.22 418.47,186.19  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -339.4765,
    y1: -1393.2677,
    x2: -255.0199,
    y2: -1393.2677,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -123.3818 -1051.4021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D6D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M475.25,271.61h-80.61c-6.47,0-11.71-5.24-11.71-11.71l0,0c0-6.47,5.24-11.71,11.71-11.71h80.61V271.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -304.7961,
    y1: -1392.391,
    x2: -251.6811,
    y2: -1392.391,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -120.0024 -1039.9343)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B9C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8FFFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 426.23,
    y: 249.01,
    className: "st9",
    width: 49.02,
    height: 22.6
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M480.69,273.25h-86.06c-7.36,0-13.34-5.98-13.34-13.34c0-7.36,5.99-13.34,13.34-13.34h86.06v3.27h-86.06 c-5.56,0-10.08,4.52-10.08,10.08S389.07,270,394.63,270h86.06V273.25z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -339.6236,
    y1: -1341.4419,
    x2: -261.2208,
    y2: -1341.4419,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -96.7315 -1063.1892)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M465.41,198.37v-3.27h-72c-6.81,0-12.35,5.54-12.35,12.35c0,6.81,5.54,12.34,12.35,12.34h72v-3.27l0,0 V198.37L465.41,198.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -300.465,
    y1: -1342.3512,
    x2: -249.3323,
    y2: -1342.3512,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -92.3773 -1049.3796)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D6D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M475.75,218.15H433.9c-5.92,0-10.71-4.8-10.71-10.71l0,0c0-5.92,4.8-10.71,10.71-10.71h41.85V218.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -301.8235,
    y1: -1342.7557,
    x2: -244.0403,
    y2: -1342.7557,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -92.0992 -1048.4978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M480.73,219.79H433.9c-6.81,0-12.35-5.54-12.35-12.34c0-6.81,5.54-12.35,12.35-12.35h46.83v3.27H433.9 c-5.01,0-9.08,4.07-9.08,9.08c0,5,4.07,9.08,9.08,9.08h46.83L480.73,219.79L480.73,219.79z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -336.3485,
    y1: -1362.7015,
    x2: -251.892,
    y2: -1362.7015,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -108.2432 -1052.3669)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D6D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M389.5,244.94h80.61c6.47,0,11.71-5.24,11.71-11.71l0,0c0-6.47-5.24-11.71-11.71-11.71H389.5V244.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.8802,
    y1: -780.8553,
    x2: 368.0214,
    y2: -775.5446,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B9C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8FFFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "389.5,244.94 435.66,244.94 435.66,222.33 389.5,222.33  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -342.0556,
    y1: -1362.2825,
    x2: -250.5658,
    y2: -1362.2825,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -108.5601 -1053.3708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA283"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBA37D"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M470.12,246.57h-86.06v-3.27h86.06c5.56,0,10.08-4.52,10.08-10.08s-4.52-10.08-10.08-10.08h-86.06v-3.27 h86.06c7.36,0,13.34,5.99,13.34,13.34C483.46,240.58,477.47,246.57,470.12,246.57z"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M358.91,116.16h-68.6c-2.74,0-4.97-2.22-4.97-4.97V92.36c0-2.74,2.22-4.97,4.97-4.97h68.6 c2.74,0,4.97,2.22,4.97,4.97v18.83C363.88,113.94,361.66,116.16,358.91,116.16z"
  })), /*#__PURE__*/React.createElement("g", null, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "397.26,119.75 395.28,112.62 388.15,110.64 412.28,86.5 421.39,95.61  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "424.97,119.75 426.95,112.62 434.08,110.64 409.94,86.5 400.83,95.61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -325.4312,
    y1: -1224.6667,
    x2: -293.2657,
    y2: -1224.6667,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -37.9306 -1088.7493)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M427.2,91.94c0,1.68-1.27,3.14-1.76,4.66c-0.51,1.57-0.36,3.49-1.31,4.8c-0.96,1.32-2.84,1.76-4.16,2.73 c-1.31,0.95-2.31,2.61-3.88,3.12c-1.51,0.49-3.29-0.24-4.97-0.24s-3.46,0.74-4.97,0.24c-1.57-0.51-2.57-2.17-3.88-3.12 c-1.32-0.96-3.2-1.41-4.16-2.73c-0.95-1.31-0.8-3.23-1.31-4.8c-0.49-1.52-1.76-2.97-1.76-4.66c0-1.68,1.27-3.14,1.76-4.66 c0.51-1.57,0.36-3.49,1.31-4.8c0.96-1.32,2.84-1.77,4.16-2.73c1.31-0.95,2.31-2.61,3.88-3.12c1.51-0.49,3.29,0.24,4.97,0.24 s3.46-0.74,4.97-0.24c1.57,0.51,2.57,2.17,3.88,3.12c1.32,0.96,3.2,1.41,4.16,2.73c0.95,1.31,0.8,3.23,1.31,4.8 C425.93,88.81,427.2,90.26,427.2,91.94z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M413.35,84.71v13.94h-3.23V87.3h-2.79v-2.59C407.33,84.71,413.35,84.71,413.35,84.71z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -474.5805,
    y1: -1406.3582,
    x2: -432.6292,
    y2: -1406.3582,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -155.9338 -1172.6643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005AB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#28AAFF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M302.63,239.61c0,8.07-10.51,14.61-23.47,14.61s-23.47-6.54-23.47-14.61s10.51-14.6,23.47-14.6 C292.13,225.01,302.63,231.55,302.63,239.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.1677,
    y1: -790.0696,
    x2: 279.0315,
    y2: -816.0764,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M302.57,249.41v-11.55H291c-3.47-1.26-7.51-1.99-11.82-1.99s-8.35,0.73-11.82,1.99H255.7v13.67h0.07 c0.87,7.57,11.01,13.54,23.4,13.54c12.96,0,23.47-6.54,23.47-14.6C302.63,250.11,302.61,249.76,302.57,249.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: -492.0991,
    y1: -1403.656,
    x2: -427.2663,
    y2: -1403.656,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -151.8857 -1174.2864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "318.15,241.97 239,241.97 256.71,221.5 300.44,221.5  "
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M279.63,232.33c-1.12,1.73-2.95,3.09-5.44,4.05c-1.49,0.57-3.06,0.94-4.57,1.3c-0.6,0.15-1.2,0.29-1.8,0.45 c-2.12,0.56-4.23,1.27-6.24,2.15c-0.76,0.31-1.55,0.69-2.1,1.25c-0.13,0.14-0.25,0.28-0.34,0.45h-1.22 c0.16-0.44,0.43-0.84,0.77-1.21c0.7-0.71,1.6-1.13,2.45-1.49c2.07-0.89,4.23-1.63,6.41-2.2c0.6-0.15,1.21-0.3,1.82-0.45 c1.48-0.35,3.01-0.72,4.43-1.26c2.27-0.86,3.92-2.08,4.91-3.61c0.16-0.25,0.5-0.33,0.75-0.16 C279.72,231.74,279.79,232.08,279.63,232.33z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 239,
    y1: -788.224,
    x2: 318.08,
    y2: -788.224,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAD3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EABB8"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 241.97,
    className: "st23",
    width: 79.08,
    height: 1.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -488.6089,
    y1: -1407.818,
    x2: -448.8597,
    y2: -1407.818,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -160.9408 -1180.3704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAD3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EABB8"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M251.72,260.35c-0.16,0-0.31-0.07-0.42-0.2c-3.35-4.02-5.01-8.58-4.68-12.83 c0.4-5.06,3.91-9.43,8.35-10.39c1.44-0.31,2.95-0.29,4.41-0.26c2.17,0.04,4.22,0.08,5.93-0.96c1.3-0.79,2.23-2.13,3.13-3.44 c0.19-0.27,0.37-0.54,0.56-0.81c1.02-1.43,2.64-3.36,4.96-3.64c2.44-0.31,3.51,1.01,4.75,2.53c0.26,0.32,0.54,0.66,0.85,1.01 c0.2,0.23,0.18,0.57-0.05,0.77c-0.22,0.2-0.57,0.18-0.77-0.05c-0.32-0.36-0.61-0.71-0.88-1.05c-1.2-1.48-1.93-2.36-3.77-2.14 c-1.44,0.18-2.78,1.19-4.2,3.2c-0.19,0.26-0.37,0.53-0.55,0.79c-0.96,1.4-1.96,2.84-3.46,3.75c-1.98,1.19-4.28,1.15-6.51,1.11 c-1.4-0.03-2.84-0.05-4.16,0.23c-3.98,0.86-7.13,4.82-7.49,9.41c-0.31,3.97,1.26,8.25,4.43,12.05c0.19,0.23,0.16,0.57-0.07,0.77 C251.97,260.31,251.84,260.35,251.72,260.35z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: -484.263,
    y1: -1426.0441,
    x2: -477.6457,
    y2: -1426.0441,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -171.8359 -1182.5286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAD3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EABB8"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M250.75,258.35l-0.23,6.66c0.47,0.07,2,0.24,3.58-0.66c1.44-0.81,2.09-2.03,2.3-2.48 C254.52,260.7,252.64,259.53,250.75,258.35z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -274.6007,
    y1: -1353.2579,
    x2: -252.8388,
    y2: -1353.2579,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -96.6395 -1039.8835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "468.54,231.82 463.55,228.56 458.56,231.82 458.56,208.13 468.54,208.13  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.66,
    y1: -813.5588,
    x2: 183.3785,
    y2: -813.5588,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M183.61,267.81c-0.07,0.2-0.25,0.74-0.23,1.02c0.37,0.19,2.38,0.86,8.55,0.51c2.89-0.17,4.89,0.69,5.96,0.73 c2.68,0.12,3.74-0.33,3.77-0.87c-0.12-1.06-0.5-3.07-0.5-3.07L183.61,267.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.7325,
    y1: -814.6361,
    x2: 208.7996,
    y2: -814.6361,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M208.96,271.33c-0.21,0.69-0.2,1.23-0.05,1.48s0.59,1.07,3.06,1c3.26-0.09,4.84-1.11,8.06-2.49 c3.03-1.29,4.4-2,4.67-3.23s-1.23-3.53-1.23-3.53l-6.14,3.5L208.96,271.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.62,
    y1: -810.6678,
    x2: 201.39,
    y2: -810.6678,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M196.92,261.87c-1.02,0.91-2.86,1.64-5.26,2.26c-2.71,0.7-3.91,1.26-6.46,1.64 c-1.45,0.32-1.58,1.04-1.58,2.04c2.31,0.68,4.39,0.63,6.33,0.41c1.94-0.23,4.62-0.4,6.26,0.15c1.84,0.3,4.82,0.3,5.18-0.29 c-0.14-1.67-0.81-5.92-0.81-5.92L196.92,261.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.9091,
    y1: -812.4536,
    x2: 224.0919,
    y2: -812.4536,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M218.55,262.38c-1.07,1.78-2.64,3.03-4.18,4.5c-0.94,0.89-3.46,2.39-4.44,3.19 c-0.99,0.81-1.26,1.71-0.81,1.98c0.45,0.27,2.77,0.51,4.61,0c3.2-0.89,4.82-1.98,7.51-3.22c2.56-1.18,3.05-2.22,2.79-3.23 c-0.27-1.01-0.81-3.94-0.81-3.94L218.55,262.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -923.2382,
    y1: -1778.3098,
    x2: -901.8223,
    y2: -1778.3098,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -45.7481 -1818.9993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAD3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EABB8"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M235.08,172.23c-6.21-1.82-19.47-7.61-21.67-11.41c3.24-10.16,10.07-13.82,13.26-16.81 c0.49,0.19,0.89,0.39,1.2,0.61c1.23,0.81,1.27,1.66,1.27,1.66c-0.63,1.81-5.39,8.28-8.49,12.15c-0.09,0.12-0.18,0.24-0.28,0.35 c7.4,1.49,13.71,3.43,18.78,6.43C244.21,168.2,235.08,172.23,235.08,172.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -943.9635,
    y1: -1784.7477,
    x2: -938.8525,
    y2: -1784.7477,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -56.3575 -1833.5236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B9C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8FFFF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M202.62,175.12l0.13-0.14c0.41-0.41,0.41-1.07,0-1.48l-11.55-11.55c-0.41-0.41-1.07-0.41-1.48,0l-0.13,0.13 c-0.41,0.41-0.41,1.07,0,1.48l11.55,11.55C201.55,175.53,202.21,175.53,202.62,175.12z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M229.13,146.28c-0.63,1.81-5.39,8.28-8.49,12.15c-0.29-0.14-0.54-0.33-0.7-0.62 c-0.21-0.4-0.19-0.88-0.1-1.31c0.22-1.04,0.85-1.96,1.47-2.84c1.53-2.16,3.08-4.29,4.68-6.39c0.26-0.34,1.01-1.5,1.87-2.66 C229.09,145.43,229.13,146.28,229.13,146.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.2023,
    y1: -776.5665,
    x2: 207.9428,
    y2: -809.5194,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9B183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBD6B6"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M238.88,198.81c0,0-11.05,24.37-19.88,34.14c-1.36,3.29-9.75,22.3-17.64,30.35c-0.62,0-1.23,0-1.81-0.02 c-1.43-0.06-2.7-0.3-3.67-1.12c5.96-12.2,15.71-32.16,15.71-32.16l10.92-35l14.14,3.29L238.88,198.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: -923.1582,
    y1: -1799.3281,
    x2: -884.8638,
    y2: -1799.3281,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -56.2335 -1811.2893)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAD3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EABB8"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M246.65,171.55c-0.1,0.51-0.21,1.06-0.35,1.62c-2.05,8.4-4.2,10.8-7.04,23.81c-0.13,0.59-0.26,1.2-0.39,1.83 c-1.12,5.42-14.03,0.23-16.56-2.71c0.44-2.17,0.99-4.16,1.56-6.13c1.32-4.48,2.73-8.9,3.08-15.27c0.04-0.62,0.06-1.26,0.08-1.93 c0.02-0.83,0.22-1.65,0.61-2.39c1.92-3.65,6.66-9.39,6.66-9.39l9.26-1.31C244.84,162.73,247.99,164.2,246.65,171.55z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M238.88,198.81c0,0-11.05,24.37-19.88,34.14c-1.62,8.66-9.75,22.3-17.64,30.35c-0.62,0-1.23,0-1.81-0.02 c0.24-0.45,0.52-0.88,0.8-1.3c1.77-2.7,3.47-5.46,5.08-8.26c0.66-1.16,1.3-2.33,1.88-3.53c1.72-3.65,2.72-7.61,4.44-11.26 c2.84-6.04,8.58-10.3,12.15-15.93c3.25-4.66,3.27-11.42,6.69-15.85c1.81-2.36,3.58-6.38,6.08-8.85L238.88,198.81z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M245.45,167.83c-1.19,5.66-9.89,19.08-21.57,22.14c1.31-4.48,2.73-8.91,3.08-15.27 c1.34-1.59,3.86-2.17,6.79-5.2c3.07-3.17,4-4.64,4-4.64L245.45,167.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: -942.317,
    y1: -1847.3002,
    x2: -887.9685,
    y2: -1847.3002,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -84.3736 -1811.092)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9B183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBD6B6"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M226.4,211.97c-3.61,4.48-9.94,11.8-17.34,16.47c6.56,8.51,9.41,12.94,15.3,33.81 c-0.48,0.18-0.94,0.36-1.4,0.51c-1.96,0.66-3.79,0.92-6-0.51c-1.11-4.22-7.32-13.86-16.19-32.33c-0.93-1.94,0.05-4.32,1.21-6.14 c7.72-12.14,15.65-22.79,20.53-28.78c1.93,2.33,7.05,3.52,11.79,3.82c1.62,0.1,3.2,0.1,4.59-0.01 C239.66,208.75,232.25,208.46,226.4,211.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.93,
    y1: -696.159,
    x2: 242.59,
    y2: -696.159,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCCA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E59B6C"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M242.59,158.7l-0.18,0.02l-3.92,0.43l-1.59,0.17l-0.32-3c-1.81,2.01-4.61,3.87-7.21-0.09 c-1.94-2.88-3.13-5-3.91-8.28c-0.2-0.86-0.39-1.8-0.53-2.86l16.23-2.99l1.43,16.52L242.59,158.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M242.58,158.63l-0.17,0.09l-3.76,1.79c0.05-0.47-0.02-0.92-0.16-1.37c-0.48-1.57,0.02-2.09,0.15-3.76 c0.03-0.38-0.53-2.3-0.64-2.68c-0.23-0.91-2.6-0.48-3.29-1.1c-1.32-1.19-0.45-3.61-1.55-5.01c-0.49-0.64-1.32-0.95-2.13-1 c-0.81-0.04-1.61,0.14-2.4,0.32l-3.18,2.05c-0.2-0.86-0.39-1.8-0.53-2.86l16.23-2.99L242.58,158.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: -914.2859,
    y1: -1762.9343,
    x2: -895.1477,
    y2: -1762.9343,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -37.2183 -1818.8107)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE355"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AA9C00"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M241.9,150.48c-2.92-0.05-1.18-3.86-3.43-3.86s-1.24,2.95-2.97,1.59c-2.34-1.62-2.5-3.75-5.86-2.6 s-4.32,2.67-5.93,2.07c-1.61-0.6,0.79-4.06-1-5.09c-2-1.16-0.77-3.64,1.56-4.56c1.91-0.76,6.33-2.7,10.18-0.52 c1.33-1.47,5.36-0.64,5.52,1.34C243.22,139.81,242.27,145.24,241.9,150.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.05,
    y1: -716.8164,
    x2: 205.37,
    y2: -716.8164,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCCA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E59B6C"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M203.05,175.64c-0.82-0.1-4.89-0.23-6.41-1.62c-1.53-1.4-4.52-5.85-5.59-6.4c1.07-1.33,3.51,0.13,4.32,1.46 c0.81,1.33,3.41,3.38,4.61,3.48c0.26-1.4-0.29-1.79-1.17-2.24c-0.84-0.46-1.04-2.18-0.62-2.63c0.22-0.16,1.1,1.1,1.72,1.3 c0.62,0.19,1.72,1.1,1.82,1.79c0.1,0.68,0.9,2.65,1.46,2.7c0.56,0.05,2.18,0.88,2.18,0.88L203.05,175.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: -932.8176,
    y1: -1791.6716,
    x2: -891.8151,
    y2: -1791.6716,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -54.9281 -1817.7756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAD3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EABB8"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M245.4,167.43c-0.02,1.02-0.45,2.11-1.35,3.16c-4.32,4.95-9.49,15.11-20.81,16.57 c-10.33-2.53-19.16-8-20.34-10.33c0.03-0.49,0.09-0.93,0.15-1.32c0.48-2.68,1.67-3.01,2.78-3.27c4.18,2.54,11.98,5.46,16.96,8.09 c8.31-5.58,9.72-7.44,15.4-16.92C240.28,159.95,245.51,164.23,245.4,167.43z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M226.4,211.97c-3.61,4.48-9.94,11.8-17.34,16.47c6.56,8.51,9.41,12.94,15.3,33.81 c-0.48,0.18-0.94,0.36-1.4,0.51c-1.08-0.8-1.99-1.88-2.63-3.05c-1.36-2.49-1.77-5.37-2.2-8.16c-0.56-3.76-1.2-7.56-2.66-11.09 c-1.45-3.52-3.8-6.78-7.11-8.67c-0.84-0.48-1.82-0.95-2.13-1.87c-0.35-1,0.27-2.08,0.97-2.87c2.41-2.72,6-4.08,8.76-6.45 c5.23-4.49,7.2-12.38,13.3-15.6c1.56-0.82,3.4-1.36,4.43-2.79c0.8-1.11,0.62-2.25,0.62-3.38c1.62,0.1,3.2,0.1,4.59-0.01 C239.66,208.75,232.25,208.46,226.4,211.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: -906.9196,
    y1: -1779.416,
    x2: -894.2137,
    y2: -1779.416,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -45.3292 -1812.9357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAD3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EABB8"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M234.72,159.64l-3.33,3.77c-0.06,0.07,0,0.17,0.09,0.15l12.63-3.01l-1.21-2.73l-6.69,1 C235.64,158.92,235.11,159.21,234.72,159.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: -915.4161,
    y1: -1814.1592,
    x2: -901.9379,
    y2: -1814.1592,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -65.5074 -1810.6926)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M222.8,193.54c-0.69,0.74-0.94,2.26-0.94,2.26s7.91,5.69,17.02,3.84c0.19-0.82,0.48-1.46,0.52-2.29 C239.4,197.35,231.71,198.61,222.8,193.54z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M245.4,167.43c-0.02,1.02-0.45,2.11-1.35,3.16c-4.32,4.95-9.49,15.11-20.81,16.57 c-10.33-2.53-19.16-8-20.34-10.33c0.03-0.49,0.09-0.93,0.15-1.32c1.43,0.16,2.22,1.16,3.06,2.29c2,2.69,3.93,2.24,6.6,3.99 c2.42,1.6,8.1,2.88,11.01,2.82c2.78-0.06,5.39-2.1,7.65-3.73c3.27-2.36,4.92-3.06,6.63-5.25c1.81-2.3,3.91-3.29,5.06-4.89 C243.92,169.54,244.27,167.31,245.4,167.43z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M246.65,171.55c-0.1,0.51-0.21,1.06-0.35,1.62c-2.05,8.4-4.2,10.8-7.04,23.81c-0.5-0.8-0.98-1.61-1.38-2.46 c-0.96-2.03-1.48-4.42-0.68-6.51c0.51-1.35,1.51-2.43,2.37-3.59c1.96-2.63,3.23-5.7,4.48-8.74c0.42-1.02,0.78-2.91,1.63-3.67 C245.94,171.79,246.27,171.64,246.65,171.55z"
  }))), /*#__PURE__*/React.createElement("g", null, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M372.44,252.28c-0.47,1.99-2.23,5.01-4.13,7.9c-2.71,4.11-5.73,7.91-5.73,7.91l-2.84-2.11 c0,0,4.22-11.24,8.06-13.89c-4.04-2.84-10.6-14.11-10.6-14.11l3.76-4.46c0.51,0.31,1.02,0.68,1.52,1.11 C367.43,238.91,371.49,248.83,372.44,252.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.48,
    y1: -792.8589,
    x2: 372.44,
    y2: -792.8589,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DB1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDFFFF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M372.44,252.28c-0.47,1.99-2.23,5.01-4.13,7.9c-0.51-1.91-0.2-4.02,0.88-5.67c0.59-0.91,1.43-1.77,1.46-2.85 c0.01-0.51-0.17-1-0.35-1.48c-0.6-1.6-1.26-3.18-1.96-4.74c-1.21-2.73-2.57-5.38-4.06-7.97c-0.34-0.58-1.69-2.05-1.8-2.83 C367.43,238.91,371.49,248.83,372.44,252.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.1199,
    y1: -846.5145,
    x2: 344.1089,
    y2: -846.5145,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#595651"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#312A20"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M343.29,297.46c-0.05,0.12-0.11,0.24-0.16,0.37c-1.27,3.05-2.34,8.73-6.03,10.55 c-3.4,1.68-3.66-2.92-1.94-6.8c0.86-1.94,1.84-3.03,2.23-4.12s0.18-2.18,0.58-3.18c0.51-1.28,2.47-1,4.93-0.24 C345.37,294.79,343.29,297.46,343.29,297.46z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M342.54,294.78c-1.46,0.58-1.77,2.01-2.46,3.59c-0.48,1.1-1.35,2.17-2.03,3.46 c-1.7,3.22,1.29,4.51,2.62,2.11c0.64-1.15,2.22-5.76,3.71-6.39s0.59-2.65,0.59-2.65L342.54,294.78z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M327.63,252.65c1.5,1.03,3.04,3.38,4.37,5.84c2.1,3.86,3.67,8.05,3.67,8.05l-2.84,2.11 c0,0-8.71-10.98-9.84-15.81c1.03-3.8,5.87-15.45,11.47-18.76l3.76,4.46c0,0-0.64,1.08-1.61,2.66 C334.4,244.71,330.4,250.68,327.63,252.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: -166.0924,
    y1: -1438.9761,
    x2: -141.5137,
    y2: -1438.9761,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -355.8752 -1043.7986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94765A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5D4837"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M348.48,208.88c-3.2-2.64-9.41,1.39-11.16,6.68c-1.28,3.88-0.75,7.9,2.14,13.3c2.89,5.4-1.43,7.95-1.43,7.95 h7.28l3.86-16.61L348.48,208.88z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M360.4,273.7h-23.51c0,0,6.2-17.34-2.44-39.6c5.24-2.52,13.63-5.84,13.63-5.84s7.52,3.45,12.88,5.25 C355.15,244.59,360.4,273.7,360.4,273.7z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M358.85,240.68c-2.13,3.5-1.37,10.41-3.31,11.97s-10.75-0.27-13.59,1.79c4.36,5.18,17.95,3.8,17.95,3.8 l-1.61-3.79L358.85,240.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.7931,
    y1: -795.3005,
    x2: 336.6064,
    y2: -795.3005,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DB1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDFFFF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M332,258.49c-0.25,0.07-0.52,0.09-0.78,0.02c-0.7-0.17-1.19-0.81-1.61-1.4c-0.74-1.02-1.47-2.05-2.2-3.07 c-0.31-0.43-0.64-0.92-0.6-1.46c0.03-0.49,0.36-0.91,0.68-1.28c1.07-1.26,2.14-2.52,3.19-3.79c0.51-0.25,1.08-1.27,1.46-1.72 c0.49-0.57,0.97-1.15,1.46-1.72c0.54-0.66,1.9-2.96,2.81-2.92c0.08,0,0.16,0.01,0.21,0.03c-2.2,3.5-6.21,9.48-8.98,11.45 C329.13,253.68,330.67,256.03,332,258.49z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M344.06,219.81v10.65h0.05v2.37c0,2.19,1.78,3.97,3.97,3.97s3.97-1.78,3.97-3.97v-2.37v-1.61v-9.04H344.06z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M344.06,219.81v10.65h0.05v2.37c0,2.19,1.78,3.97,3.97,3.97s3.97-1.78,3.97-3.97v-2.37v-1.61v-9.04H344.06z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M342.46,220.88c0.21,1.01-0.1,1.94-0.69,2.06c-0.6,0.13-1.25-0.6-1.46-1.61s0.1-1.94,0.69-2.06 C341.59,219.14,342.24,219.86,342.46,220.88z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M342.46,220.88c0.21,1.01-0.1,1.94-0.69,2.06c-0.6,0.13-1.25-0.6-1.46-1.61s0.1-1.94,0.69-2.06 C341.59,219.14,342.24,219.86,342.46,220.88z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M354.21,223.97c-1.58,3.42-3.34,5.16-4.7,5.85c-0.15,0.08-0.29,0.14-0.42,0.19c-0.36,0.14-0.69,0.2-0.96,0.2 c-1.35,0-4.3-2.11-5.77-6.25c-1.17-3.3-2.02-5.25-1.01-8.09c0.3-0.84,0.74-1.51,1.31-2.04c1.35-1.26,3.34-1.68,5.48-1.68 c0.71,0,1.42,0.08,2.13,0.22c2.26,0.45,3.73,1.34,4.4,2.41C355.54,216.19,356.43,219.22,354.21,223.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.443,
    y1: -1436.8909,
    x2: -140.0504,
    y2: -1436.8909,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -352.9653 -1037.658)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M356.25,221.04c-0.27,1.07-1,1.8-1.63,1.64s-0.91-1.16-0.64-2.22c0.27-1.07,1-1.8,1.63-1.64 C356.24,218.97,356.52,219.97,356.25,221.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: -172.5129,
    y1: -1495.814,
    x2: -141.2535,
    y2: -1495.814,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -387.0519 -1034.2527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M326.66,284.74c5.23,2.67,27.06-0.26,33.05-1.14c1.53-0.21,1.32-4.31-0.02-4.77 c-2.57-1.06-23.45-2.08-31.24-1.55C323.37,277.58,322.64,282.68,326.66,284.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: -175.4226,
    y1: -1481.2722,
    x2: -127.4279,
    y2: -1481.2722,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -378.0204 -1034.094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B9C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8FFFF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M369.07,277.5h-42.88v-22.13c0-0.52,0.42-0.94,0.94-0.94h41.01c0.52,0,0.94,0.42,0.94,0.94v22.13H369.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: -134.2719,
    y1: -1505.7461,
    x2: -169.3955,
    y2: -1481.1526,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -384.6252 -1032.0115)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B9C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8FFFF"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 326.18,
    y: 277.5,
    className: "st52",
    width: 42.88,
    height: 2.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: -160.0791,
    y1: -1501.3954,
    x2: -123.6338,
    y2: -1501.3954,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -386.7983 -1025.2053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M371.81,282.14c-6.06,4.93-23.53,15.18-26.24,15.8c-0.14,0.05-0.28,0.05-0.43,0.01 c-1.4-0.24-3.35-2.94-2.34-3.9c4.39-4.17,20.52-19.18,26.33-20.02c2.56-0.38,4.38,1.31,4.69,3.4 C374.07,278.99,373.5,280.78,371.81,282.14z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M354.21,223.97c-1.58,3.42-3.34,5.16-4.7,5.85c-0.15,0.08-0.29,0.14-0.42,0.19c-0.1-0.1-0.19-0.2-0.29-0.32 c-0.85-1.08-0.95-2.59-0.7-3.94c0.24-1.35,0.8-2.63,1.17-3.96c0.36-1.33,0.53-2.79,0.01-4.06c-0.43-1.03-1.27-1.82-2.23-2.36 c-0.5-0.28-1.03-0.5-1.58-0.68c-0.68-0.23-1.14-0.03-1.83-0.11c-0.4-0.05-0.82-0.27-0.97-0.65c-0.01-0.03-0.02-0.06-0.02-0.09 c1.35-1.26,3.34-1.68,5.48-1.68c0.71,0,1.42,0.08,2.13,0.22c2.26,0.45,3.73,1.34,4.4,2.41 C355.54,216.19,356.43,219.22,354.21,223.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: -152.3495,
    y1: -1440.8257,
    x2: -133.7463,
    y2: -1440.8257,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -355.5815 -1038.9387)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94765A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5D4837"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M348.09,209.14c5.01-3.53,10.74,3.66,10.64,7.25c-0.1,3.59,1.87,12.47-1.84,15.24 c-3.63,2.71-1.12,8.25-1.77,9.32c-4.34-3.88-6.28-9.56-3.66-16.38s0.6-9.61-7.67-10.85C344.21,210.56,348.09,209.14,348.09,209.14 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.0461,
    y1: -762.1498,
    x2: 379.5908,
    y2: -762.1498,
    gradientTransform: "matrix(1 0 0 -1 0 -545.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94765A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5D4837"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M348.48,208.88c1.4,3.15-2.85,7.92-7.12,10.23c-2.66,2.08-1.98,3.76-3.49,6.33 c-2.44-6.08-0.64-10.78,1.2-13.28C344.11,205.34,348.48,208.88,348.48,208.88z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M371.81,282.14c-6.06,4.93-23.53,15.18-26.24,15.8c-0.14,0.05-0.28,0.05-0.43,0.01 c0.29-0.45,0.72-0.84,1.14-1.19c6.19-5.21,12.96-9.7,20.16-13.37c1.57-0.8,3.16-1.56,4.56-2.63c0.65-0.49,1.24-1.06,1.75-1.69 c0.37-0.45,0.65-1.23,1.08-1.64C374.07,278.99,373.5,280.78,371.81,282.14z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 290.6494 106.6569)",
    className: "st2 st56 st57"
  }, "formation")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormation);
export default __webpack_public_path__ + "static/media/formation.4e32f2e18db9f4612e64f12b50ae2953.svg";
export { ForwardRef as ReactComponent };